export default {
  allDay: 'כל היום',
  previous: '<',
  next: '>',
  today: 'היום',
  month: 'חודש',
  week: 'שבוע',
  day: 'יום',
  agenda: 'רשימה',
  date: 'תאריך',
  time: 'זמן',
  event: 'אירוע',
  showMore: (total: number) => `+ (${total}) אירועים`,
};
//tranlations to hebrew
